export default __webpack_public_path__ + "static/hero-l5-bg-d22ff1de8ec1bd9458576c8443b567c9.jpg";